<template>
  <div class="txn-wrap">
    <div id="txRequest" class="line-chart"></div>
  </div>
</template>

<script>
let echarts = require('echarts')
export default {
  name: 'TxnLine',
  data() {
    return {
      chart: null,
      intervalId: null,
      min: 0,
      max: null,
      option: {
        grid: {
          left: '1%',
          right: '8%',
          bottom: '8%',
          top: '5%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          // data: ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
          axisLine: {
            // 调整轴线颜色
            lineStyle: {
              color: '#306269'
            }
          },
          axisTick: {
            // 去掉刻度
            show: false
          },
          axisLabel: {
            textStyle: {
              color: '#fff'
            }
          }
        },
        yAxis: {
          type: 'value',
          min: this.min,
          max: this.max,
          axisLabel: {
            textStyle: {
              color: '#fff'
              // fontWeight: 'bold'
            }
          },
          splitLine: {
            axisLabel: {
              textStyle: {
                color: 'green' // 设置为绿色
              }
            },
            lineStyle: {
              color: '#306269',
              width: 0.5
            }
          }
        },
        series: [
          {
            type: 'line',
            smooth: 'none',
            symbol: 'none',

            label: {
              show: true
            }
            // lineStyle: {
            //     color: '#FFCC00',
            //     width: 2,
            //     type: 'solid'
            // }
          }
        ]
      }
    }
  },
  watch: {
    '$store.state.home.chainCid'(newValue) {
      if (newValue) this.getData()
    }
  },

  mounted() {
    this.initChart()
    this.getData()
    this.intervalId = setInterval(() => {
      this.getData()
    }, 10000)
    window.addEventListener('resize', this.resize, false)
  },
  destroyed() {
    // 清除定时器和图表实例
    clearInterval(this.intervalId)
    this.chart.dispose()
  },
  methods: {
    initChart() {
      let container = document.getElementById('txRequest')
      let chart = echarts.init(container)
      chart.setOption(this.option)
      this.chart = chart
    },
    resize() {
      this.chart.resize()
    },
    getData() {
      let cid = this.$store.state.home.chainCid
      let params = {
        chain_id: cid,
        data_type: 2,
        query_range: 0,
        query_step: '',
        query_time: Math.floor(Date.now() / 1000)
      }
      this.$apis.home.getMultiple(params).then(res => {
        if (res.data) {
          // let result = this.handleLine(res.data)
          const yTimeArray = res.data.time_axis.map((item, index) => {
            return this.timestampToTime(item)
          })
          var seriesArray = []
          var numArray = []
          res.data.multiple_data.map((item, index) => {
            var obj = {}
            // obj.data = item.nums;
            obj.data = item.nums
            obj.name = item.instance
            obj.symbol = 'none'
            obj.smooth = true

            obj.type = 'line'
            if (index == 0) {
              obj.areaStyle = {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: '#00CBFF' },
                  { offset: 1, color: 'rgba(0,0,0,0)' }
                ])
              }
              obj.itemStyle = {
                emphasis: {
                  opacity: 0
                },
                color: '#00CBFF',
                borderWidth: 1,
                borderColor: '#00CBFF'
              }
            } else if (index == 1) {
              obj.areaStyle = {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: '#FFCC00' },
                  { offset: 1, color: 'rgba(0,0,0,0)' }
                ])
              }
              obj.itemStyle = {
                emphasis: {
                  opacity: 0
                },
                color: '#FFCC00',
                borderWidth: 1,
                borderColor: '#FFCC00'
              }
            } else if (index == 2) {
              obj.areaStyle = {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: '#e6762c' },
                  { offset: 1, color: 'rgba(0,0,0,0)' }
                ])
              }
              obj.itemStyle = {
                emphasis: {
                  opacity: 0
                },
                color: '#FFCC00',
                borderWidth: 1,
                borderColor: '#FFCC00'
              }
            } else if (index == 3) {
              obj.areaStyle = {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: '#27dfed' },
                  { offset: 1, color: 'rgba(0,0,0,0)' }
                ])
              }
              obj.itemStyle = {
                emphasis: {
                  opacity: 0
                },
                color: '#FFCC00',
                borderWidth: 1,
                borderColor: '#FFCC00'
              }
            } else if (index == 4) {
              obj.areaStyle = {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: '#fd3838' },
                  { offset: 1, color: 'rgba(0,0,0,0)' }
                ])
              }

              obj.itemStyle = {
                emphasis: {
                  opacity: 0
                },
                color: '#FFCC00',
                borderWidth: 1,
                borderColor: '#FFCC00'
              }
            }

            obj.label = {
              show: true,
              position: 'right',
              fontSize: 12,
              color: '#00CBFF'
            }
            seriesArray.push(obj)
            numArray.push(item.nums)
          })
          const maxVal = Math.max.apply(null, numArray.flat())
          this.max = Math.ceil(maxVal + maxVal / 3)
          this.chart.setOption({
            xAxis: {
              data: yTimeArray
            },
            yAxis: {
              min: this.min,
              max: this.max
            },
            series: seriesArray
          })
        }
      })
    },
    handleLine(data) {
      let hour = []
      let num = []
      data.map(ele => {
        let time = this.format(ele.Hourtime)
        hour.push(time)
        num.push(ele.Num)
      })
      return [hour, num]
    },
    add0(m) {
      return m < 10 ? '0' + m : m
    },
    timestampToTime(timestamp) {
      let date = new Date(timestamp * 1000) // Fri Aug 26 2022 01:09:43 GMT+0800 (中国标准时间)
      let Y = date.getFullYear() + '-'
      let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
      let D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
      let h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
      let m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':'
      let s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
      return h + m + s
    },
    format(timeStamp) {
      let time = new Date(timeStamp * 1000)
      let m = time.getMonth() + 1
      let d = time.getDate()
      let h = time.getHours()
      let mm = time.getMinutes()
      let s = time.getSeconds()
      return this.add0(m) + '-' + this.add0(d) + ' ' + this.add0(h) + ':' + this.add0(mm)
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~@/styles/compatible/index.scss';

.real-wrap,
.line-chart {
  @include px2vw(width, 400);
  @include px2vw(height, 250);
}
</style>
